export enum ApiInfo {
  ApiUrl = 'apiinfo://api-url',
  BaseSite = 'apiinfo://base-site',
  BearerToken = 'apiinfo://bearer-token',
  ClientId = 'apiinfo://client-id',
  ClientSecret = 'apiinfo://client-secret',
  DashboardClientId = 'apiinfo://dashboard-client-id',
  DashboardClientSecret = 'apiinfo://dashboard-client-secret',
  DebugEndpoint = 'apiinfo://debug-endpoint',
  EnvironmentType = 'apiinfo://environment-type',
  FacebookAppId = 'apiinfo://facebook-app-id',
  GatewayUrl = 'apiinfo://gateway-url',
  LaunchDarklyMobileKey = 'apiinfo://launch-darkly-mobile-key',
  LibraryClientId = 'apiinfo://library-client-id',
  LibraryClientSecret = 'apiinfo://library-client-secret',
  LogScreenClientId = 'apiinfo://log-screen-client-id',
  LogScreenClientSecret = 'apiinfo://log-screen-client-secret',
  MoesifApplicationId = 'apiinfo://moesif-application-id',
  OnboardingClientId = 'apiinfo://onboarding-client-id',
  OnboardingClientSecret = 'apiinfo://onboarding-client-secret',
  PlanetFitnessAudience = 'apiinfo://planet-fitness-audience',
  PlanetFitnessClientId = 'apiinfo://planet-fitness-client-id',
  PlanetFitnessDomain = 'apiinfo://planet-fitness-domain',
  PlanetFitnessScope = 'apiinfo://planet-fitness-scope',
  RaygunId = 'apiinfo://raygun-id',
  SegmentId = 'apiinfo://segment-id',
  SpeedTestEndpoint = 'apiinfo://speed-test-endpoint',
}
export type ApiInfoStrings = keyof typeof ApiInfo;

export enum AppInfo {
  Version = 'appinfo://version',
  ColorScheme = 'appinfo://color-scheme',
  IsFirstRun = 'appinfo://is-first-run',
}
export type AppInfoStrings = keyof typeof AppInfo;

export enum ConsoleInfo {
  SoftwareNumber = 'consoleinfo://software-number',
  ConsoleType = 'consoleinfo://console-type',
  IsClubUnit = 'consoleinfo://is-club-unit',
  MinSpeed = 'consoleinfo://min-speed',
  MaxSpeed = 'consoleinfo://max-speed',
  MinIncline = 'consoleinfo://min-incline',
  MaxIncline = 'consoleinfo://max-incline',
  MinResistance = 'consoleinfo://min-resistance',
  MaxResistance = 'consoleinfo://max-resistance',
  UnitPreference = 'consoleinfo://unit-preference',
}
export type ConsoleInfoStrings = keyof typeof ConsoleInfo;

export enum CoreInfo {
  ConsoleConnectionInitialized = 'core://ILocalSettings/Console/Connection/Initialized',
  UserHeight = 'core://IIfitApiService/CurrentlyAuthenticatedUser/Height',
  SelectedSoftwareNumber = 'core://ILocalSettings/SoftwareNumber',
  LastKnownConsoleType = 'core://ILocalSettings/LastKnownConsoleType',
}
export type CoreInfoStrings = keyof typeof CoreInfo;

export enum DeviceInfo {
  DeviceType = 'deviceinfo://device-type',
  Platform = 'deviceinfo://platform',
  Orientation = 'deviceinfo://orientation',
  ScreenHeight = 'deviceinfo://screen-height',
  ScreenWidth = 'deviceinfo://screen-width',
  CurrentDate = 'deviceinfo://current-date',
  CurrentTime = 'deviceinfo://current-time',
  CurrentTimeZone = 'deviceinfo://current-time-zone',
  DeviceName = 'deviceinfo://device-name',
  SafeAreaPaddingLeft = 'deviceinfo://safe-area-padding-left',
  SafeAreaPaddingTop = 'deviceinfo://safe-area-padding-top',
  SafeAreaPaddingRight = 'deviceinfo://safe-area-padding-right',
  SafeAreaPaddingBottom = 'deviceinfo://safe-area-padding-bottom',
  DeviceAnything = 'deviceinfo://anything',
}
export type DeviceInfoStrings = keyof typeof DeviceInfo;

export enum Library {
  EntryPoint = 'library://entry-point',
}
export type LibraryStrings = keyof typeof Library;

export enum UserInfo {
  IsLoggedIn = 'userinfo://is-logged-in',
  UserId = 'userinfo://user-id',
  MembershipType = 'userinfo://user-membership-type',
  IsPlanetFitnessUser = 'userinfo://is-planet-fitness-user',
  UnitPreference = 'userinfo://unit-preference',
  IsPaused = 'userinfo://is-paused',
}
export type UserInfoStrings = keyof typeof UserInfo;

export enum WorkoutInfo {
  RecordId = 'workout://record-id',
  ProgramId = 'workout://program-id',
  WorkoutId = 'workout://workout-id',
  ScheduleId = 'workout://schedule-id',
  AnalyticsWorkoutSource = 'workout://analytics-workout-source',
  AnalyticsDashboardIndex = 'workout://analytics-dashboard-index',
  IsPreWorkout = 'workout://is-pre-workout',
  RecordContext = 'workout://record-context',
}
export type WorkoutInfoStrings = keyof typeof WorkoutInfo;

export const GOOD_COP_KEYS = {
  ApiInfo,
  AppInfo,
  ConsoleInfo,
  CoreInfo,
  DeviceInfo,
  Library,
  UserInfo,
  WorkoutInfo,
};

export type IGoodCopKey =
  | ApiInfoStrings
  | AppInfoStrings
  | ConsoleInfoStrings
  | CoreInfoStrings
  | DeviceInfoStrings
  | LibraryStrings
  | UserInfoStrings
  | WorkoutInfoStrings
  | string;
